import styled from 'styled-components';

export const NotificationShowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  max-width: 10rem;
  max-height: 10rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #f8f9fa;

  & > input {
    width: 100%;
  }
`;

export const ToggleShowWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  padding: 0.5rem 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    & > svg {
      transform: scale(1.1);
    }
  }
`;
